import { ValueOf } from '@approvalmax/types';
import { domain } from 'modules/data';
import { useDeleteNetSuiteExpenseLinesMatching, useDeleteNetSuiteItemLinesMatching } from 'shared/data/webApp/v2';

export const useDeleteMatching = (lineType: ValueOf<domain.NetSuiteMatchingLineType>) => {
    const { mutate: deleteItemLinesMatching, isLoading: isLoadingDeleteItemLinesMatching } =
        useDeleteNetSuiteItemLinesMatching();

    const { mutate: deleteExpenseLinesMatching, isLoading: isLoadingDeleteExpenseLinesMatching } =
        useDeleteNetSuiteExpenseLinesMatching();

    if (lineType === domain.NetSuiteMatchingLineType.Item) {
        return {
            deleteMatching: deleteItemLinesMatching,
            isLoadingDeleteMatching: isLoadingDeleteItemLinesMatching,
        };
    }

    return {
        deleteMatching: deleteExpenseLinesMatching,
        isLoadingDeleteMatching: isLoadingDeleteExpenseLinesMatching,
    };
};
